import styles from "../styles/Groups.module.css";
import { Card, Container, Row } from "react-bootstrap";
import Logo from "../assets/logo.png";
import { Link, useParams } from "react-router-dom";
import { User } from "../models/user";
import { BsFillHouseFill } from "react-icons/bs";
import { Group2Schema } from "../models/Group2Items";
import { Group1Schema } from "../models/Group1Items";

interface Group1PageProps {
    loggedInUser: User | null;
    group1: Group1Schema[];
    group2: Group2Schema[];
}

const Group1Page = ({ loggedInUser, group1, group2 }: Group1PageProps) => {

    const currGroup1 = useParams<{ category: string }>();
    const g1Parent = group1.find(grp1 => (Number(grp1.CODE) === Number(currGroup1.category)));

    return (
        <>
            {loggedInUser
                ?
                <>
                    <ol className="breadcrumb bg-dark px-4 d-flex">
                        <Link to={"/"} className="text-light px-2">
                            <BsFillHouseFill />
                        </Link>
                        <span className="breadcrumb-divider">{'>'}</span>
                        <span className="active text-light px-2">{g1Parent?.NAME}</span>
                    </ol>

                    <Container fluid className="pt-2">
                        <Row xs={1} sm={1} md={1} lg={1} xl={1} className={` ${styles.groupRow} px-0 justify-content-center fs-6`}>
                        {group2.filter((item) => (Number(item.GRP1) === Number(currGroup1.category) ? item : null)).map(group => (
                            <Card key={group.ID} as={Link} to={`/g2/${group.ID}`} className={`${styles.groupCard} shadow rounded border-0 p-0 g-3 g-sm-4 mx-0 mx-sm-4 my-1 my-sm-2 bg-dark d-flex flex-row-reverse`}>
                                <Row className={`${styles.groupCardArrow} fs-5 text-secondary align-items-center justify-content-center m-0 p-0`}>
                                    <Card.Text className="text-center p-0">{'>'}</Card.Text>
                                </Row>
                                <Row className={`${styles.groupCardText} bg-light align-items-center mx-0 p-0`}>
                                    <Card.Text className={`${styles.groupCardTex} text-dark text-center`}>{group.NAME}</Card.Text>
                                </Row>
                                <Row className={`${styles.groupCardImg} align-items-center text-center justify-content-center m-0 p-0`}>
                                <Card.Img variant="top" src={Logo} className="p-0"></Card.Img>
                                </Row>
                            </Card>
                        ))}
                        </Row>
                    </Container >
                </>
                : <></>
            }
        </>
    );
}

export default Group1Page;